import { faqCusto, faqDados, faqProgramar, faqSistema } from './shared'
import type { ProfessionPageConfig } from './types'

export const rh: ProfessionPageConfig = {
  path: '/ia-para-rh-e-departamento-pessoal/',
  key: 'rh',
  title: 'IA para RH e departamento pessoal | Oficina IA',
  description:
    'Três tarefas do RH e do DP que a IA adianta numa pasta: checklist de admissão por pessoa, declarações a partir da lista de funcionários e a planilha de férias.',
  imageAlt: 'Oficina IA: IA para RH e departamento pessoal',
  whatsappMessage: 'Olá, Arthur. Vim pela página de IA para RH e departamento pessoal e quero saber sobre o acompanhamento.',
  lastmod: '2026-09-25',
  heading: 'IA para RH e departamento pessoal',
  intro:
    'Admissão, documento, férias, vencimento: tudo por pessoa, todo mês. E é o setor que mais ouve que "a IA vai cuidar disso". Aqui estão três tarefas dessa rotina que a IA pode ajudar a adiantar, com você conferindo, sem programar.',
  rogerio: { pose: 'conferindo', text: 'Uma pasta por pessoa. Eu confiro o que falta.' },
  tasks: [
    {
      title: 'Checklist de admissão',
      tone: 'sky',
      brings: 'a pasta de documentos de quem está entrando.',
      helps: 'lista o que chegou e o que falta, por pessoa.',
      continues: 'cobra só o que falta.',
    },
    {
      title: 'Declarações a partir da lista',
      tone: 'peach',
      brings: 'um modelo e a lista de funcionários.',
      helps: 'preenche uma declaração por pessoa e salva na pasta.',
      continues: 'confere e assina.',
    },
    {
      title: 'Férias e vencimentos',
      tone: 'sage',
      brings: 'a planilha de admissões.',
      helps: 'monta o calendário de férias e vencimentos, com aviso por mês.',
      continues: 'confere as datas antes de avisar.',
    },
  ],
  steps: {
    do: 'A IA monta o checklist, as declarações ou o calendário dentro da sua pasta.',
    check: 'Confira nomes e datas antes de usar. A IA pode se enganar; a folha é responsabilidade sua.',
    resume: 'No mês seguinte, troque a lista e repita o pedido.',
  },
  faq: [faqProgramar, faqSistema('sistema de folha'), faqDados('dos funcionários'), faqCusto],
  closing: {
    title: 'Sua primeira admissão sem pilha, com alguém do lado.',
    text: 'Traga a admissão da semana, a leva de declarações ou a planilha de férias.',
    rogerio: 'Eu cuido do novelo. Você cuida das pessoas.',
  },
}
